import { IPD_ADMIT_PATIENT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface IpdPatient {
    bed: string;
    department: Department;
    category: Category;
    refer: Refer;
    insurance: Insurance;
    attendee: Attendee;
    patient: Patient;
    date: string;
    ipid: string;
    docid: string;
    doc: {
        name: string;
        id: string;
    };
    duration: Duration;
    rateplan: {
        inclusions: {
            rate: number;
            name: string;
            id: string;
        }[];
        name: string;
        id: string;
    };
}

export interface Duration {
    value: number;
    unit: string;
}

interface Department {
    name: string;
    id: string;
}

interface Category {
    name: string;
    id: string;
}

interface Refer {
    name: string;
    id: string;
}

interface Insurance {
    pre_approved_id?: string;
    pre_approved_amount?: number;
    pre_approved?: boolean;
    number?: string;
    type?: string;
}

interface Attendee {
    phone: Phone;
    name: string;
    id: string;
}

interface Phone {
    n?: string;
    c?: string;
}

interface Patient {
    formData: FormData[];
    profile: Profile;
    poid: string;
    uuid: string;
    id: string;
}

interface FormData {
    label: string;
    type: 'number' | 'string' | 'select';
    key: string;
    value: string | number;
}

interface Profile {
    personal: Personal;
}

interface Personal {
    gender: string;
    phone?: Phone;
    age?: any;
    name: string;
}

interface Age {
    dob: string;
}

interface Response {
    success: boolean;
    message?: string;
}

export default (ipdPatient: IpdPatient): Promise<Response> => {
    return fetchWithRefresh(IPD_ADMIT_PATIENT, {
        method: 'POST',
        body: JSON.stringify(ipdPatient),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
